import React, { useEffect, useState } from "react";

const ScrollToTopButton = () => {
  const [scroll, setScroll] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScroll(scrolled);
      setShow(scrollTop > 100);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const radius = 28;
  const stroke = 5;
  const normalizedRadius = radius - stroke * 0.5;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (scroll / 100) * circumference;

  return (
    show && (
      <div
        onClick={scrollToTop}
        style={{
          position: "fixed",
          bottom: "40px",
          right: "40px",
          width: "70px",
          height: "70px",
          zIndex: 999,
          cursor: "pointer",
        }}
      >
        <svg width="70" height="70">
          <circle
            stroke="#2a2a2a"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx="35"
            cy="35"
          />
          <circle
            stroke="#fff"
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            r={normalizedRadius}
            cx="35"
            cy="35"
          />
          <polygon
            points="35,20 25,38 45,38"
            fill="#ccc"
          />
        </svg>
      </div>
    )
  );
};

export default ScrollToTopButton;
